/* Brand Wall motion — follows the lsc-motion house rules:
   GSAP + ScrollTrigger must already be loaded (deferred, earlier in doc order);
   no-op in the theme editor; reduced-motion via gsap.matchMedia; every finished
   tween clears its inline props so CSS state rules stay the owner at rest.
   The row does NOT float (removed at owner's request) and the sheen is CSS-only
   (brand-wall.css) so it can never get caught mid-animation / render stuck. */
(function () {
  'use strict';
  if (!window.gsap || !window.ScrollTrigger) return; /* CSS fallback covers hover */
  if (window.Shopify && window.Shopify.designMode) return;
  gsap.registerPlugin(ScrollTrigger);

  var CLEAR = 'transform,opacity,visibility';
  function q(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function inView(el, pad) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight - (pad || 0) && r.bottom > 0;
  }

  q('.brand-wall').forEach(function (section) {
    section.classList.add('brand-wall--js');
    var heading = section.querySelector('.brand-wall__heading');
    var tiles = q('.brand-wall__tile', section);
    if (!tiles.length) return;

    var mm = gsap.matchMedia();

    /* ---------- entrance: heading, then tiles bloom center-out ---------- */
    mm.add('(prefers-reduced-motion: no-preference)', function () {
      var toReveal = tiles.filter(function (el) { return !inView(el, 40); });
      if (heading && !inView(heading, 40)) toReveal.unshift(heading);
      if (toReveal.length) {
        var hs = toReveal.filter(function (el) { return el === heading; });
        var ts = toReveal.filter(function (el) { return el !== heading; });
        if (hs.length) gsap.set(hs, { autoAlpha: 0, y: 16 });
        if (ts.length) gsap.set(ts, { autoAlpha: 0, y: 26, scale: 0.94 });
        ScrollTrigger.create({
          trigger: section, start: 'clamp(top 88%)', once: true,
          onEnter: function () {
            var tl = gsap.timeline({ onComplete: function () {
              /* if a tile is already hovered when the entrance finishes, clearing its
                 transform would yank the hover lift flat for a frame — clear only
                 paint props there and let the hover system keep owning transform */
              var hovered = toReveal.filter(function (el) { return el.matches && el.matches(':hover'); });
              var rest = toReveal.filter(function (el) { return hovered.indexOf(el) === -1; });
              if (rest.length) gsap.set(rest, { clearProps: CLEAR });
              if (hovered.length) gsap.set(hovered, { clearProps: 'opacity,visibility' });
            } });
            if (hs.length) tl.to(hs, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out' });
            if (ts.length) tl.to(ts, {
              autoAlpha: 1, y: 0, scale: 1, duration: 0.55, ease: 'back.out(1.7)',
              stagger: { each: 0.06, from: 'center' }, overwrite: 'auto'
            }, hs.length ? '-=0.3' : 0);
          }
        });
      }
      return function () { };
    });

    /* ---------- hover: lift + tilt + cursor glow (fine pointers).
       Sheen is CSS-only now, so it is not driven here. ---------- */
    mm.add('(prefers-reduced-motion: no-preference) and (pointer: fine)', function () {
      var cleanups = tiles.map(function (tile) {
        var logo = tile.querySelector('.brand-wall__logo');
        var yTo = gsap.quickTo(tile, 'y', { duration: 0.35, ease: 'power2.out' });
        var rxTo = gsap.quickTo(tile, 'rotationX', { duration: 0.4, ease: 'power2.out' });
        var ryTo = gsap.quickTo(tile, 'rotationY', { duration: 0.4, ease: 'power2.out' });
        var mx = gsap.quickSetter(tile, '--mx', '%');
        var my = gsap.quickSetter(tile, '--my', '%');
        var rect = null; /* cached in enter(): reading it per-move forces layout AND feeds the tilting tile's own moving rect back into the math */

        function move(e) {
          var r = rect || tile.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;   /* 0..1 */
          var py = (e.clientY - r.top) / r.height;
          mx(px * 100); my(py * 100);
          ryTo((px - 0.5) * 8);   /* max +/-4deg */
          rxTo((0.5 - py) * 8);
        }
        function enter() {
          rect = tile.getBoundingClientRect(); /* pre-transform snapshot */
          gsap.set(tile, { transformPerspective: 600 });
          yTo(-6);
          if (logo) gsap.to(logo, { scale: 1.06, duration: 0.35, ease: 'power2.out', overwrite: 'auto' });
        }
        function leave() {
          rect = null;
          yTo(0); rxTo(0); ryTo(0);
          /* also reset scale: without pointer capture a press-drag-off means up() may
             never fire on this tile, which used to leave it stuck at 0.97 */
          gsap.to(tile, { scale: 1, duration: 0.25, ease: 'power2.out', overwrite: 'auto' });
          if (logo) gsap.to(logo, { scale: 1, duration: 0.4, ease: 'power2.out', overwrite: 'auto' });
        }
        function down(e) {
          if (e.pointerId != null && tile.setPointerCapture) {
            try { tile.setPointerCapture(e.pointerId); } catch (err) { /* capture is best-effort */ }
          }
          gsap.to(tile, { scale: 0.97, duration: 0.12, ease: 'power2.out', overwrite: 'auto' });
        }
        function up() { gsap.to(tile, { scale: 1, duration: 0.25, ease: 'back.out(2)', overwrite: 'auto' }); }

        tile.addEventListener('pointermove', move);
        tile.addEventListener('pointerenter', enter);
        tile.addEventListener('pointerleave', leave);
        tile.addEventListener('pointerdown', down);
        tile.addEventListener('pointerup', up);
        return function () {
          tile.removeEventListener('pointermove', move);
          tile.removeEventListener('pointerenter', enter);
          tile.removeEventListener('pointerleave', leave);
          tile.removeEventListener('pointerdown', down);
          tile.removeEventListener('pointerup', up);
          gsap.set(tile, { clearProps: 'all' });
          if (logo) gsap.set(logo, { clearProps: 'all' });
        };
      });
      return function () { cleanups.forEach(function (fn) { fn(); }); };
    });
  });
})();
